export default __webpack_public_path__ + "static/media/021-meter.026d6cb2.svg";